<template>
    <!-- AnyTest連携 -->
    <fieldset id="anytest" v-if="!isSelectBrowser">
        <legend>AnyTest連携(任意)</legend>
        <div>
            AnyTest連携時に使用するデータを入力してください。
            <AnyTestHelp /><br>
            AnyTestを使用することで、スマートフォンやタブレットの実機テストが可能になります。<br>
            詳しくは
            <a href="https://service.valtes.co.jp/t-dash/function/tutorial/topic/anytest_linkage"
                target="_blank">T-DASHチュートリアル</a>
            または
            <a href="https://service.valtes.co.jp/anytest/" target="_blank">AnyTestサービスサイト</a>
            をご覧ください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. AnyTestを使用する場合、テストラン作成時にテスト環境でAnyTestを設定してください。
            <TestEnvHelp /><br>
        </div>
        <div class="form-area">
            <!-- 必須 -->
            <label for="anytestUser">・ユーザ名</label><br>
            <input type="text" class="input-text" id="anytestUser" v-model="inputedAnyTest.user" name="anytestUser"
                @input="updateOpt" placeholder="your_account"><br>
            <label for="anytestApi">・APIキー</label><br>
            <input type="text" class="input-text" id="anytestApi" v-model="inputedAnyTest.apiKey" name=" anytestApi"
                @input="updateOpt" placeholder="your_api"><br>
            <label for="anytestDeviceId">・デバイスID</label><br>
            <input type="text" class="input-text" id="anytestDeviceId" v-model="inputedAnyTest.deviceId"
                name="anytestDeviceId" @input="updateOpt" placeholder="162"><br>
            <!-- 任意 -->
            <label for="anytestRuntime">・実行時間</label><br>
            <input type="text" class="input-text" id="anytestRuntime" v-model="inputedAnyTest.runTime"
                name=" anytestRuntime" @input="updateOpt" placeholder="5">
        </div>
    </fieldset>

    <!-- AnyTest用プロキシ -->
    <fieldset v-if="isNeedAnyTest && isSilent && !isSelectBrowser" id="anytestProxy">
        <legend>AnyTest連携用プロキシ(任意)</legend>
        <div>
            AnyTest連携時に使用するプロキシを入力してください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. この設定が必要かどうかはネットワーク管理者に確認してください。<br>
            2. 非対話型で実行する時に、プロキシを使用する場合は必ず入力してください。<br>
            3. アドレスとポートが全て入力された時のみ、それら全てを設定するオプションが追加されます。<br>
            4. アドレスとポート、アカウント名、パスワードが全て入力された時のみ、それら全てを設定するオプションが追加されます。
        </div>
        <div class="form-area">
            <label for="anytestProxyAddress">・アドレス</label><br>
            <input type="text" class="input-text" id="anytestProxyAddress" v-model="inputedAnyTestProxy.address"
                name="anytestProxyAddress" @input="updateOpt" placeholder="xxx.xxx.xxx.xxx"><br>
            <label for="anytestProxyPort">・ポート番号</label><br>
            <input type="text" class="input-text" id="anytestProxyPort" v-model="inputedAnyTestProxy.port"
                name="anytestProxyPort" @input="updateOpt" placeholder="8888"><br>
            <label for="anytestProxyAccount">・アカウント</label><br>
            <input type="text" class="input-text" id="anytestProxyAccount" v-model="inputedAnyTestProxy.account"
                name="anytestProxyAccount" @input="updateOpt" placeholder="your_account"><br>
            <label for="anytestProxyPassword">・パスワード</label><br>
            <input type="text" class="input-text" id="anytestProxyPassword" v-model="inputedAnyTestProxy.password"
                name="anytestProxyPassword" @input="updateOpt" placeholder="your_password"><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, reactive, ref, watch } from 'vue';

import makeOpt from '@/js/makeOpt.js'
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'AnyTestForm',
    props: {
        isSilent: { type: Boolean, default: true },
        optDict: { type: Object, default: () => { } }
    },
    setup(props, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        // AnyTest
        const inputedAnyTest = reactive({
            user: '',
            apiKey: '',
            deviceId: 162,
            runTime: 5,
        })
        const inputedAnyTestProxy = reactive({
            address: '',
            port: '',
            account: '',
            password: '',
        })

        // ##############
        // 外部連携フラグ #
        // * reactiveで宣言した場合、watchを使う
        // ##############
        const isNeedAnyTest = ref(false)

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            // サイレント
            let createdOpt = ""

            // AnyTest
            isNeedAnyTest.value = await makeOpt.isNeedAnyTestOpt(inputedAnyTest)
            if (isNeedAnyTest.value && !isSelectBrowser.value) {
                createdOpt += await makeOpt.createAnyTestOpt(inputedAnyTest)
                createdOpt += await makeOpt.createProxyOpt("anytest", inputedAnyTestProxy, props.isSilent)
            }

            // cacheに保存
            await cacheUtils.saveData("anyTestUser", inputedAnyTest.user)
            await cacheUtils.saveData("anyTestApiKey", inputedAnyTest.apiKey)
            await cacheUtils.saveData("anyTestDeviceId", inputedAnyTest.deviceId)
            await cacheUtils.saveData("anyTestRunTime", inputedAnyTest.runTime)
            await cacheUtils.saveData("anyTestProxyAddress", inputedAnyTestProxy.address)
            await cacheUtils.saveData("anyTestProxyPort", inputedAnyTestProxy.port)
            await cacheUtils.saveData("anyTestProxyAccount", inputedAnyTestProxy.account)
            await cacheUtils.saveData("anyTestProxyPassword", inputedAnyTestProxy.password)


            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "anytest", createdOpt)
        }

        // ############
        // propsの監視 #
        // * propsをcomputedに入れると無限に呼び出されるため、watchで関数を発火させる
        // ############
        // サイレントモード設定の監視
        watch(
            () => props.isSilent,
            async () => {
                await updateOpt()
            }
        )

        // 通常ブラウザを選択時、AnyTestは設定できない
        const isSelectBrowser = ref(false)
        watch(
            () => props.optDict?.browser,
            async () => {
                isSelectBrowser.value = props.optDict?.browser.includes(" --browser")
                await updateOpt()
            }
        )

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            inputedAnyTest.user = await cacheUtils.getData("anyTestUser")
            inputedAnyTest.apiKey = await cacheUtils.getData("anyTestApiKey")
            inputedAnyTest.deviceId = await cacheUtils.getData("anyTestDeviceId", "162")
            inputedAnyTest.runTime = await cacheUtils.getData("anyTestRunTime", "5")
            inputedAnyTestProxy.address = await cacheUtils.getData("anyTestProxyAddress")
            inputedAnyTestProxy.port = await cacheUtils.getData("anyTestProxyPort")
            inputedAnyTestProxy.account = await cacheUtils.getData("anyTestProxyAccount")
            inputedAnyTestProxy.password = await cacheUtils.getData("anyTestProxyPassword")

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedAnyTest,
            inputedAnyTestProxy,
            // コマンド生成
            updateOpt,
            // 外部連携フラグ
            isNeedAnyTest,
            // ブラウザ設定フラグ
            isSelectBrowser,

        }
    }
}
</script>
